export default __webpack_public_path__ + "static/media/ER.8fe26692.svg";